import { render } from "./guide.vue?vue&type=template&id=08857429&scoped=true"
import script from "./guide.vue?vue&type=script&lang=js"
export * from "./guide.vue?vue&type=script&lang=js"

import "./guide.vue?vue&type=style&index=0&id=08857429&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-08857429"

export default script